import React, {useMemo, useState} from 'react';
import LoyaltyPoints from "components/loyaltyBadges/loyaltyPoints";
import {Card} from "react-bootstrap";
import styles from "components/loyaltyBadges/loyaltyBadge/styles.js"
import classnames from 'classnames'
import {FormattedMessage} from "react-intl";
import UCButton from "components/buttons";
import {useTheme} from "react-jss";
import moment from "helpers/moment";
import {useLocaleContext} from "contexts/localeContext";
import LoyaltyRedeem from "components/loyaltyRedeem";
import {useHasPermission} from "hooks/useHasPermission";

/**
 *
 * @param {Object} props
 * @param {JSX.Element} props.allotmentTypeName
 * @param {Date} props.expirationDate
 * @param {Number} props.initialBalance
 * @param {Number} props.currentPoints
 * @param {Boolean} props.allowRedemption
 * @returns {Element}
 * @constructor
 */
function LoyaltyBadge(props) {
  const {
    className,
    allotmentTypeName,
    expirationDate,
    availableBalance,
    initialBalance,
    allotmentId,
    onRedeemCompleted,
    allowConciergeKey,
    allowRedemption
  } = props;

  const theme = useTheme();
  const classes = styles({theme});
  const globalLocale = useLocaleContext();

  const [showModal, setShowModal] = useState(false);
  const { checkPermission } = useHasPermission();

  const expireAt = useMemo(() => moment(expirationDate), [expirationDate]);
  const disabled = useMemo(() => expireAt < moment(), [expireAt]);

  return (<>
      <Card className={classnames(classes.loyaltyBadge, className, {disabled})}>
        <Card.Header className={classes.loyaltyBadgeHeader}>
          <Card.Title className={classes.loyaltyBadgeTitle}>
            {allotmentTypeName}
          </Card.Title>
          <Card.Text className={classes.loyaltyBadgeSubtitle}>
            <FormattedMessage id="loyalty.card.expiresAt"
                              values={{expiresAt: expireAt.locale(globalLocale).format('MMM DD, YYYY')}}/>
          </Card.Text>
        </Card.Header>
        <Card.Body className={classes.loyaltyBadgeBody}>
          <LoyaltyPoints availableBalance={availableBalance} initialBalance={initialBalance}/>
        </Card.Body>
        <Card.Footer className={`${classes.loyaltyBadgeButton} ${!allowRedemption && classes.loyaltyBadgeNoBorder}`}>
          {checkPermission("F_LOYALTYPOINTS_REDEEMPOINTS") && allowRedemption ?
            <UCButton
              disabled={disabled}
              onClick={() => setShowModal(true)}
              type="primary"
              text={<div>
                <FormattedMessage id='loyalty.card.redeem'/>
              </div>}/>
            : null}
        </Card.Footer>
      </Card>

      <LoyaltyRedeem initialBalance={availableBalance} showModal={showModal} setShowModal={setShowModal} allotmentId={allotmentId} onRedeemCompleted={onRedeemCompleted} allowConciergeKey={allowConciergeKey}/>
    </>
  );
}

export default LoyaltyBadge;